<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Assign Handler</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type"
            placeholder="Please Select"
            v-model="form.handler"
            label="Handler"
            :options="handlers"
            :required="true"
            :show-error="form.errors.has('handler')"
            label-name="full_name"
            :error-message="form.errors.get('handler')"
            key-name="id"
          ></selectlist>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button
        :indicator="form.processing()"
        v-on:clicked="assignToHandler"
      >
        Assign To Handler
      </form-button>
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    handlers: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      form: new window.Form({
        handler: null
      })
    };
  },

  methods: {
    closeModal() {
      this.form.reset();
      this.$emit('close');
    },

    assignToHandler() {
      this.form
        .post('/incidents/' + this.incident + '/assign')
        .then(response => {
          this.$emit('assigned', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Oops, there was an error assigning the document to the handler'
          );
        });
    }
  }
};
</script>
